module.exports = __webpack_public_path__ + "h5/img/logo.5a7fe01a.png";